<!-- 首页 -->
<template>
  <div class="home-page">
    <div class="top">
      <div class="top-bg">
        <div class="logo-box"></div>
        <div class="search-box">
          <el-input
            class="search-box-input"
            placeholder="搜索"
            prefix-icon="el-icon-search"
            @focus="toSearchView()"
          >
          </el-input>
          <div class="icon-item">
            <i class="iconfont icon-zglsdingyue" @click="dialogVisible = true">
              <div class="red-cir"></div>
            </i>
            <div>订阅</div>
          </div>
          <div class="icon-item">
            <i class="iconfont icon-zglsdiannao" @click="toPC()"></i>
            <div>PC版本</div>
          </div>
        </div>
        <div class="headlines">
          <img
            class="headlines-img"
            src="../assets/images/headlines.png"
            alt=""
          />
          <div
            class="headlines-title"
            v-if="indexData.frontPage"
            @click="toDetail(indexData.frontPage.id, indexData.frontPage)"
          >
            {{ indexData.frontPage.properties.frontPageTitle }}
            <div class="headlines-date">
              {{ formatDate(indexData.frontPage.properties.publishedDate) }}
            </div>
          </div>
          <div class="headlines-minor" v-if="indexData.secondaryFrontPageList">
            <span
              v-for="item in indexData.secondaryFrontPageList"
              :key="item.id"
              @click="toDetail(item.parentId, item)"
            >
              {{ item.properties.title }}&nbsp;&nbsp;|&nbsp;&nbsp;
            </span>
            <div class="headlines-more" @click="toListView('headlines')">
              更多 <i class="iconfont icon-zglsgengduo"></i>
            </div>
          </div>
        </div>
        <div class="carousel-box">
          <el-carousel>
            <el-carousel-item v-for="(item, index) in imageList" :key="index">
              <div v-if="item.properties" style="width: 100%; height: 100%">
                <img
                  class="all-img"
                  :src="'site/file/' + item.properties.carouselFile"
                  alt=""
                  @click="toDetail(item.id, item)"
                />
                <div class="carousel-title">
                  {{ item.properties.carouselTitle || item.properties.title }}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="lawyer-home">
        <div class="lawyer-home-top">
          <img
            class="lawyer-home-top-img1"
            src="../assets/images/home.png"
            alt=""
          />
          <img
            class="lawyer-home-top-img2"
            src="../assets/images/lawyer.png"
            alt=""
          />
          <span class="lawyer-home-top-text">快捷入口，一键进入</span>
        </div>
        <div class="lawyer-home-content">
          <div class="lawyer-home-item" @click="toRightProtection('home')">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglsweiquanguanli"></i>
            </div>
            <div class="lawyer-home-item-text">
              全国律协<br />维护律师执业权利中心
            </div>
          </div>

          <div class="lawyer-home-item" @click="toComplainView('home')">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglstousujianyi"></i>
            </div>
            <div class="lawyer-home-item-text">
              全国律协<br />投诉受理查处中心
            </div>
          </div>

          <div class="lawyer-home-item">
            <a href="https://oa.acla.org.cn/login.jsp">
              <div class="lawyer-home-item-icon">
                <i class="iconfont icon-zglsgongzuotai-"></i>
              </div>
              <div class="lawyer-home-item-text">
                全国律师<br />综合管理信息系统
              </div>
            </a>
          </div>

          <div class="lawyer-home-item">
            <a href="https://credit.acla.org.cn/">
              <div class="lawyer-home-item-icon">
                <i class="iconfont icon-zglsxitong"></i>
              </div>
              <div class="lawyer-home-item-text">
                全国律师<br />诚信信息公示平台
              </div>
            </a>
          </div>

          <div class="lawyer-home-item">
          <a href="https://oralreview.acla.org.cn/#/qr-login">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglskoushenshenqing"></i>
            </div>
            <div class="lawyer-home-item-text">
              律师担任专利权无效宣告<br />
              案件口头审理代理人<br />
              申请平台
            </div>
          </a>
        </div>

        <div class="lawyer-home-item">
          <a href="https://oralreview.acla.org.cn/#/publicity">
            <div class="lawyer-home-item-icon">
              <i class="iconfont icon-zglskoushenchaxun"></i>
            </div>
            <div class="lawyer-home-item-text">

              推荐律师担任专利权<br />
              无效宣告案件口头审理<br />
              代理人名单查询入口
            </div>
          </a>
        </div>
        </div>
      </div>
      <div class="news" id="law">
        <div class="news-top">
          <div class="news-top-moretitle">
            <div
              v-for="(item, index) in lawList"
              :key="index"
              :class="
                law === index
                  ? 'active-newtitle news-top-moretitle-item'
                  : 'news-top-moretitle-item'
              "
              @click="law = index"
            >
              {{ item.label }}
              <img
                v-show="law === index"
                class="news-top-moreimg"
                src="../assets/images/text-bg.png"
                alt=""
              />
            </div>
          </div>
          <div class="news-top-more" @click="toListView('law')">
            更多
            <i class="iconfont icon-zglsgengduo"></i>
          </div>
        </div>
        <div
          class="news-item"
          @click="toDetail(item.informationId,'','law')"
          v-for="(item, index) in lawContentList"
          :key="index"
        >
          <div class="news-item-title" v-html="item.label"></div>
          <div class="news-item-date">{{ formatDate(item.date) }}</div>
        </div>
      </div>
      <div class="index-banner-box">
        <a href="/catalog/cee5a15d387045ddac565bb107546cae">
          <img class="index-banner" src="../assets/images/bg2.png" alt="" />
        </a>
      </div>
      <div class="news" id="news">
        <div class="news-top">
          <div class="news-top-moretitle">
            <div
              v-for="(item, index) in newsList"
              :key="index"
              :class="
                news === index
                  ? 'active-newtitle news-top-moretitle-item'
                  : 'news-top-moretitle-item'
              "
              @click="news = index"
            >
              {{ item.label }}
              <img
                v-show="news === index"
                class="news-top-moreimg"
                src="../assets/images/text-bg.png"
                alt=""
              />
            </div>
          </div>
          <div class="news-top-more" @click="toListView('news')">
            更多
            <i class="iconfont icon-zglsgengduo"></i>
          </div>
        </div>
        <div
          class="news-item"
          @click="toDetail(item.informationId,'','news')"
          v-for="(item, index) in newsContentList"
          :key="index"
        >
          <div class="news-item-title" v-html="item.label"></div>
          <div class="news-item-date">{{ formatDate(item.date) }}</div>
        </div>
      </div>
      <div class="index-banner-box">
        <a href="/catalog/d01a7371fe3040ed85aaaad2fec8dc72">
          <img class="index-banner" src="../assets/images/bg3.png" alt="" />
        </a>
      </div>
      <div class="news" id="dynamic">
        <div class="news-top">
          <div class="news-top-moretitle">
            <div
              v-for="(item, index) in dynamicList"
              :key="index"
              :class="
                dynamic === index
                  ? 'active-newtitle news-top-moretitle-item'
                  : 'news-top-moretitle-item'
              "
              @click="changeBynamic(index, item.dataId)"
            >
              {{ item.label }}
              <img
                v-show="dynamic === index"
                class="news-top-moreimg"
                src="../assets/images/text-bg.png"
                alt=""
              />
            </div>
          </div>
          <div class="news-top-more" @click="toListView('dynamic')">
            更多
            <i class="iconfont icon-zglsgengduo"></i>
          </div>
        </div>
        <div
          class="news-item"
          @click="toDetail(item.informationId,'','dynamic')"
          v-for="(item, index) in dynamicContentList"
          :key="index"
        >
          <div class="news-item-title" v-html="item.label"></div>
          <div class="news-item-date">{{ formatDate(item.date) }}</div>
        </div>
      </div>
    </div>

    <div class="menu">
      <div class="menu-item">
        <img :src="menuImgLeft" class="menu-img" alt="" />
        <div class="menu-text">首页</div>
      </div>
      <div class="menu-line"></div>
      <div class="menu-item" @click="changeMenu()">
        <img :src="menuImgRight" class="menu-img" alt="" />
        <div class="menu-text">律师之家</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="65%" height="25%">
      <div class="code-box">
        <img src="../assets/images/suspend1.png" alt="" />
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import api from "../api/index";

export default {
  name: "homePage",
  data() {
    return {
      dialogVisible: false,
      indexData: {},
      dynamic: 0,
      dynamicList: [
        {
          label: "全国律协动态",
          dataId: "index_lxdt",
          id: "f382bd29b5354881a75392192d28b664",
        },
        {
          label: "行业党建",
          dataId: "index_hydj",
          id: "808921c7c7a8400aaa3dd46a376db027",
        },
        {
          label: "行业动态",
          dataId: "index_hydt",
          id: "70ac42d8ee6448a5a8ad1d0cd853ca29",
        },
        {
          label: "业务进阶",
          dataId: "index_ywjj",
          id: "05fb418662344013b9fe273c025db721",
        },
      ],
      dynamicContentList: [],
      law: 0,
      lawList: [
        {
          label: "政法要闻",
          id: "d0da59ea88e34e098034a21da9ca8b81",
        },
      ],
      lawContentList: [],
      news: 0,
      newsList: [
        {
          label: "司法行政新闻",
          id: "fb32cc254ee342749e728d358aea2dd3",
        },
      ],
      headlinesList: [
        {
          label: "头条",
          id: "f6090bd553dd473d97c9a0dd391d8424",
        },
      ],
      newsContentList: [],
      menuImgLeft: require("../assets/images/index-menu.png"),
      menuImgRight: require("../assets/images/lawyer-menu.png"),
      imageList: [],
    };
  },
  created() {
    localStorage.setItem("menu", "home");
    this.getCarouseList();
    this.$nextTick(()=> {
      this.toFix();
    })
  },
  methods: {
    getCarouseList() {
      api.getCarouseList().then((res) => {
        if (res.data) {
          this.indexData = res.data;
          let { carouseList, index_zfyw, index_sfxz, index_lxdt } = res.data;
          this.imageList = carouseList;
          this.lawContentList = index_zfyw.itemList;
          this.newsContentList = index_sfxz.itemList;
          this.dynamicContentList = index_lxdt.itemList;
        } else {
          console.error("接口异常");
        }
      });
    },
    toFix() {
      let list = JSON.parse(localStorage.getItem("list"));
      if (list) {
        let arr = ["dynamic", "law", "news"];
        let a = document.createElement("a");
        arr.forEach((item) => {
          if (this[item + "List"][0]["label"] === list[0]["label"])
            a.href = "#" + item;
        });
        a.rel = "nofollow";
        a.target = "_self";
        setTimeout(() => {
          a.click();
          localStorage.removeItem("list")
        }, 100);
      }
    },
    toPC() {
      let a = document.createElement("a");
       const loading = this.$loading({
          lock: true,
          text: '请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      api.getConfig("PC_DOMAIN").then((res) => {
        loading.close();
        if (res.data) {
          a.href = res.data + "/?flag=showpc";
        } else {
          a.href = "/?flag=showpc";
        }
        a.click();
      });
    },
    formatDate(date) {
      return api.formatDate(date);
    },

    changeBynamic(index, dataId) {
      this.dynamic = index;
      this.dynamicContentList = this.indexData[dataId].itemList;
    },

    changeMenu() {
      this.$router.push({
        name: "lawyerHome",
      });
      localStorage.setItem("menu", "lawyerHome");
    },
    toListView(type) {
      this.$router.push({
        name: "list",
      });
      localStorage.setItem("list", JSON.stringify(this[type + "List"]));
    },
    toDetail(entityId, item, type) {
      if(type) localStorage.setItem("list", JSON.stringify(this[type + "List"]));
      if (item && item.properties.carouseSpecialCategory) {
        let a = document.createElement("a");
        a.href = "/catalog/" + item.properties.carouseSpecialCategory;
        a.click();
      } else {
        this.$router.push({
          name: "detail",
          params: { entityId: entityId, from: "home" },
        });
      }
    },
    toSearchView() {
      this.$router.push({
        name: "searchView",
      });
    },
    toRightProtection() {
      this.$router.push({
        name: "rightProtection",
      });
    },
    toComplainView() {
      this.$router.push({
        name: "complainView",
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.home-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f7f8fa;
  .code-box {
    text-align: center;
  }
  .top {
    overflow: auto;
    width: 100%;
    height: calc(100% - 3.5rem);
  }
  .top-bg {
    width: 100%;
    height: 34.44rem;
    padding: 3.13rem 1rem 1rem 1rem;
    box-sizing: border-box;
    background-image: url("@/assets/images/index-bg.png");
    background-repeat: no-repeat;
    background-size: contain;
    text-align: left;
    .logo-box {
      margin: 0 auto;
      margin-bottom: 1.25rem;
      width: 14.3rem;
      height: 3.13rem;
      background-image: url("@/assets/images/bg-top.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .search-box {
      display: flex;
      margin-bottom: 1.69rem;
      width: 100%;
      height: 3.25rem;
      padding: 0.5rem 0;
      box-sizing: border-box;
      .search-box-input {
        flex: 1;
        height: 2.25rem;
        background: #ffffff;
        border-radius: 1.19rem;
        :deep .el-input__inner {
          border-radius: 1.19rem;
          height: 100%;
        }
      }
      .icon-item {
        margin: 0 0 0 1.25rem;
        text-align: center;
        font-weight: 500;
        font-size: 0.75rem;
        color: #ffffff;
        line-height: 1.08rem;
        .iconfont {
          font-size: 1.33rem;
          color: #ffffff;
        }
      }
      .icon-zglsdingyue {
        position: relative;
      }
      .red-cir {
        position: absolute;
        top: -4px;
        right: -2px;
        width: 0.63rem;
        height: 0.63rem;
        background: #ee0a24;
        border-radius: 0.5rem;
        border: 0.06rem solid #ffffff;
      }
    }
    .headlines {
      position: relative;
      margin-bottom: 1rem;
      width: 100%;
      height: 9rem;
      padding: 0.62rem 1rem 1rem 3.13rem;
      background: linear-gradient(rgb(255 235 194) 0%, rgb(255, 255, 255) 100%);
      box-shadow: 0rem -0.25rem 0.38rem 0rem rgba(192, 192, 192, 0.15);
      border-radius: 0.75rem;
      border: 0.09rem solid #ffffff;
      box-sizing: border-box;
      .headlines-img {
        position: absolute;
        left: 0;
        top: -0.44rem;
        width: 2.75rem;
        height: 4.63rem;
      }
      .headlines-title {
        position: relative;
        margin-bottom: 0.5rem;
        width: 100%;
        height: 2.75rem;
        overflow: hidden;
        font-weight: 500;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.38rem;
      }
      .headlines-date {
        position: absolute;
        right: 3px;
        bottom: 0;
        width: 5rem;
        height: 1.38rem;
        padding-top: 0.16rem;
        box-sizing: border-box;
        text-align: right;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.45);
        background-color: #fff1d4;
      }
      .headlines-minor {
        position: relative;
        height: 3.88rem;
        width: 100%;
        overflow: hidden;
        font-weight: 400;
        font-size: 0.88rem;
        color: rgba(0, 0, 0, 0.45);
        line-height: 1.25rem;
      }
      .headlines-more {
        position: absolute;
        right: 3px;
        bottom: 0;
        width: 3.52rem;
        height: 1.38rem;
        padding-top: 0.16rem;
        box-sizing: border-box;
        text-align: right;
        font-weight: 500;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.06rem;
        background-color: #fffbf3;
      }
    }
    .carousel-box {
      position: relative;
      width: 100%;
      height: 12rem;
      .all-img {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        object-fit: contain;
        background-color: #b60000;
      }
      .carousel-title {
        position: absolute;
        bottom: 1.13rem;
        left: 0;
        width: 100%;
        height: 1.49rem;
        padding: 0 0.75rem;
        box-sizing: border-box;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.81rem;
        color: #ffffff;
        line-height: 1.49rem;
        text-align: justify;
        font-style: normal;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      :deep .el-carousel__container {
        height: 12rem !important;
      }
      //隐藏掉鼠标悬浮出现的左右切换按钮
      ::v-deep .el-carousel__arrow {
        display: none;
      }
      // 圆点样式
      :deep .el-carousel__indicator--horizontal .el-carousel__button {
        width: 0.38rem;
        height: 0.38rem;
        background: transparent;
        background: #ebedf0;
        border-radius: 50%;
        opacity: 0.3;
      }
      :deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
        width: 0.38rem;
        height: 0.38rem;
        background: #ffffff;
        border-radius: 50%;
        opacity: 1;
      }
    }
  }
  .lawyer-home {
    margin: 1rem 0 0.75rem 0;
    width: 100%;
    background: #ffffff;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    .lawyer-home-top {
      position: relative;
      width: 100%;
      height: 3.13rem;
      padding: 1rem 0 0 1rem;
      box-sizing: border-box;
      background: linear-gradient(
        rgba(5, 90, 215, 0.16) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      box-shadow: 0rem -0.25rem 0.38rem 0rem rgba(192, 192, 192, 0.15);
      border-radius: 0.75rem 0.75rem 0rem 0rem;
      &-img1 {
        position: absolute;
        left: 1rem;
        width: 1.13rem;
        height: 1rem;
      }
      &-img2 {
        position: absolute;
        left: 2.63rem;
        width: 4.88rem;
        height: 1.81rem;
      }
      &-text {
        position: absolute;
        left: 8.25rem;
        font-weight: 500;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.65);
        line-height: 1.06rem;
        text-align: left;
      }
    }
    .lawyer-home-content {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0.75rem 0 1rem 1rem;
      box-sizing: border-box;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      .lawyer-home-item {
        display: inline-block;
        margin-right: 0.75rem;
        height: 7.25rem;
        padding: 1.13rem 1rem 0.88rem 1rem;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0rem 0rem 0.75rem 0rem rgba(0, 0, 0, 0.05);
        border-radius: 0.5rem;
        .lawyer-home-item-icon {
          margin: 0 0 0.63rem 0;
          text-align: center;
          .iconfont {
            font-size: 1.25rem;
          }
          .icon-zglsweiquanguanli {
            color: #fc7a43;
          }
          .icon-zglstousujianyi {
            color: #8770fc;
          }
          .icon-zglsgongzuotai- {
            color: #fdab4d;
          }
          .icon-zglsxitong {
            color: #8770fc;
          }
          .icon-zglskoushenchaxun {
            color: #FDAB4D;
          }
          .icon-zglskoushenshenqing {
            color: #fc7a43;
          }
        }
        .lawyer-home-item-text {
          margin: 0 auto;
          height: 2.13rem;
          font-weight: 500;
          font-size: 0.75rem;
          color: rgba(0, 0, 0, 0.85);
          line-height: 1.06rem;
          text-align: center;
        }
      }
    }
  }
  .news {
    margin: 1rem 0;
    width: 100%;
    height: 19.25rem;
    padding: 0.63rem 1rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    .news-top {
      display: flex;
    }
    .news-top-moretitle {
      // width: 17.5rem;
      flex: 1;
      height: 1.56rem;
      font-weight: 600;
      font-size: 0.94rem;
      color: rgba(0, 0, 0, 0.65);
      line-height: 1.31rem;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      .active-newtitle {
        font-weight: 600;
        font-size: 1.13rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 1.56rem;
      }
      .news-top-moretitle-item {
        position: relative;
        display: inline-block;
        margin-right: 1rem;
        // width: 3.75rem;
        .news-top-moreimg {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 4.5rem;
          height: 0.38rem;
        }
      }
    }
    .news-top-img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 4.5rem;
      height: 0.38rem;
    }
    .news-top-more {
      // position: absolute;
      // bottom: 0;
      // right: 0;
      width: 2.94rem;
      height: 1.56rem;
      background: linear-gradient(
        270deg,
        #ffffff 0%,
        #ffffff 76%,
        rgba(255, 255, 255, 0) 100%
      );
      font-weight: 500;
      font-size: 0.75rem;
      color: rgba(0, 0, 0, 0.65);
      line-height: 1.56rem;
      text-align: right;
      .iconfont {
        font-size: 0.75rem;
      }
    }

    .news-item {
      margin-top: 0.75rem;
      width: 100%;
      height: 4.93rem;
      border-bottom: 2px solid #e7e6e4;
      .news-item-title {
        height: 3rem;
        font-weight: 500;
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.65);
        line-height: 1.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .news-item-date {
        margin: 0.25rem 0 0.5rem 0;
        text-align: right;
        font-weight: 500;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.25);
        line-height: 1.06rem;
        text-align: right;
      }
    }
    .news-item:last-child {
      border: 0;
    }
  }
  .index-banner-box {
    width: 100%;
    height: 8.25rem;
    padding: 0 1rem;
    box-sizing: border-box;
    text-align: center;
  }
  .index-banner {
    width: 100%;
    height: 100%;
  }
  .menu {
    display: flex;
    width: 100%;
    height: 3.5rem;
    background: #ffffff;
    text-align: center;
    .menu-item {
      flex: 1;
      .menu-img {
        width: 1.75rem;
        height: 1.75rem;
      }
      .menu-text {
        font-weight: 500;
        font-size: 0.69rem;
        color: rgba(0, 0, 0, 0.85);
        line-height: 0.88rem;
        text-align: center;
        font-style: normal;
      }
    }
    .menu-line {
      margin-top: 0.75rem;
      width: 0.06rem;
      height: 2rem;
      background: #e4e4e4;
    }
  }
}
</style>
